module.exports = __webpack_public_path__ + "static/media/tinyLinkConnected.aad0e6a0.svg";